<template>
  <Drawer
    v-model:visible="visible"
    position="right"
    :header="header"
    :style="{ width: width }"
    :modal="modal"
    :dismissable="dismissable"
    :class="drawerClass"
  >
    <template v-if="$slots.header" #header>
      <slot name="header" />
    </template>
    <div class="flex flex-col h-full">
      <div class="flex-1 overflow-y-auto">
        <slot />
      </div>
      <div v-if="$slots.footer" class="border-t border-gray-200 pt-4 mt-4">
        <slot name="footer" />
      </div>
    </div>
  </Drawer>
</template>

<script setup lang="ts">

const visible = defineModel<boolean>('visible', { default: false });

withDefaults(defineProps<{
  header?: string;
  width?: string;
  modal?: boolean;
  dismissable?: boolean;
  drawerClass?: string;
}>(), {
  header: '',
  width: '600px',
  modal: true,
  dismissable: true,
  drawerClass: '',
});
</script>
